import { AppThunk } from "@Store/index";
import { fetchVideoPageDataIfNeeded } from "./videoPageReducer";

const loadData = (props: any): AppThunk[] => [fetchVideoPageDataIfNeeded(props)];

export default loadData;
